import React, { Component } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import parser from 'html-react-parser'
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { API_URL } from "../../../BaseUrlApi/Url";
// import "./BlockedDates.css";

const { SearchBar } = Search;

const headers = {
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  "Content-Type": "application/json",
};

function buttonsFormatter(cell, row, rowIndex, formatExtraData) {
  return (
    <div className="detail-buttons">
      <Link to={`/update-terms/${row.id}`}>
        <button style={{margin: '.5em'}} className="btn btn-primary patient-change">Ubah</button>
      </Link>
    </div>
  );
}

class TermsConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      terms: [],
      columns: [
        {
          dataField: "text",
          text: "Deskripsi Syarat & Ketentuan",
        //   headerStyle: { textAlign: "center" },
        //   style: { textAlign: "center" },
        },
        {
          dataField: "Aksi",
          text: "Aksi",
          headerStyle: { textAlign: "center" },
          style: { margin: "auto" },
          formatter: buttonsFormatter,
        },
      ],
    };
  }
  async componentDidMount() {
      try {
        this.setState({ isLoaded: true });
        const {data} = await axios.get(`${API_URL}/admin/terms_and_conditions?type=konsultasi_online`, {
          headers,
        });
        let filterTerms = await data.terms.map(item => (
            {
                id: item.id,
                text: parser(`${item.text}`)
            }
        ))
        this.setState({
          terms: filterTerms,
        });
        this.setState({ isLoaded: false });
      } catch(e) {
        this.setState({ isLoaded: false });
        console.log(e.response.data)
        swal({
            title: `${e.response.data.message}`,
            icon: "warning",
            buttons: "OK",
            dangerMode: true,
          })
      }
    
  }
  render() {
    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total showing-button">
        Menampilkan {from} / {to} dari {size} Hasil
      </span>
    );
    const options = {
      paginationSize: 4,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "5",
          value: 5,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "All",
          value: this.state.terms.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };
    const contentTable = ({ paginationProps, paginationTableProps }) => (
      <div className="card shadow mb-4">
        <div className="card-body">
          <div className="table-responsive">
            <ToolkitProvider
              keyField="id"
              columns={this.state.columns}
              data={this.state.terms}
              search={{ searchFormatted: true }}
            >
              {(toolkitprops) => (
                <div>
                  <br />
                  <SearchBar
                    {...toolkitprops.searchProps}
                    className="search-content"
                  />
                  <BootstrapTable
                    bordered={false}
                    {...toolkitprops.baseProps}
                    {...paginationTableProps}
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>
    );
    return (
      <>
                <LoadingOverlay
          active={this.state.isLoaded}
          spinner
          text="Memuat data..."
        >
          <div className="content-section">
            <div className="title-section">
              <h1 className="patient-page-title">Syarat &amp; Ketentuan</h1>
              <h2 className="patient-page-subtitle">
                <span style={{ color: "#039BEB" }}>Master Data</span>
                <span style={{ color: "#00000029" }}> / Syarat &amp; Ketentuan</span>
              </h2>
              {/* <div className="add-button">
                <Link to="/add-bank-account">
                  <button className="btn btn-primary btn-add-table mb-2 mr-3">
                    Tambah Rekening Bank
                  </button>
                </Link>
              </div> */}
            </div>
            <PaginationProvider pagination={paginationFactory(options)}>
              {contentTable}
            </PaginationProvider>
          </div>
        </LoadingOverlay>
      </>
    );
  }
}

export default TermsConditions;
